import { Injectable } from '@treasury/utils';
import TermsAndConditionsRequests from '../../requests/account/terms-and-conditions.js';

@Injectable()
export default class TermsAndConditionsService {
    static getTermsAndConditions() {
        return TermsAndConditionsRequests.get(false);
    }

    getTermsAndConditions() {
        return TermsAndConditionsRequests.get(false);
    }

    static checkTermsAndConditions() {
        return TermsAndConditionsRequests.get(true);
    }

    static acceptTermsAndConditions() {
        return TermsAndConditionsRequests.accept();
    }
}
